import PageForgotPassword from './components/ForgotPassword';

export default PageForgotPassword;


// WEBPACK FOOTER //
// ./routes/forgot-password/index.js